import React from "react";
import { Stack, Text } from "@fluentui/react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ICatalystCustomerActionItems } from "../../../../interfaces/Catalyst.interfaces";

export interface CatalystCustomerActionItemsTableProps {
  data?: ICatalystCustomerActionItems[];
  isLoading?: boolean;
}

const columns: GridColDef[] = [
  {
    field: "title",
    headerName: "Title",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "workItemId",
    headerName: "Work Item ID",
    width: 130,
    minWidth: 110,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      const url = params.row.workItemURL;
      return url ? (
        <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "#0078D4", textDecoration: "underline" }}>
          {params.value}
        </a>
      ) : (
        <span>{params.value}</span>
      );
    },
  },
  {
    field: "workItemType",
    headerName: "Work Item Type",
    width: 130,
    minWidth: 110,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "aAssignedTo",
    headerName: "Assigned To",
    width: 140,
    minWidth: 120,
  },
  {
    field: "adoState",
    headerName: "ADO State",
    width: 120,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "blocked",
    headerName: "Blocked",
    width: 100,
    minWidth: 80,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "actionType",
    headerName: "Action Type",
    width: 120,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
  },
];

export const CatalystCustomerActionItemsTable: React.FC<CatalystCustomerActionItemsTableProps> = ({
  data,
  isLoading = false,
}) => {
  const rows = (data || []).map((item, index) => ({
    id: index,
    title: item.title ?? "-",
    workItemId: item.workItemId ?? "-",
    workItemURL: item.workItemURL ?? "",
    workItemType: item.workItemType ?? "-",
    aAssignedTo: item.aAssignedTo ?? "-",
    adoState: item.adoState ?? "-",
    blocked: item.blocked ?? "-",
    actionType: item.actionType ?? "-",
  }));

  return (
    <Stack tokens={{ childrenGap: 8 }} styles={{ root: { flex: 1 } }}>
      <Text variant="large" styles={{ root: { fontWeight: 600 } }}>
        Catalyst Customer Action Items
      </Text>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        autoHeight
        rowHeight={36}
        columnHeaderHeight={56}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25]}
        initialState={{
          pagination: { paginationModel: { pageSize: 5 } },
        }}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton" as any,
            noRowsVariant: "skeleton" as any,
          },
        }}
        sx={{
          border: "none",
          "& .MuiDataGrid-columnHeaders": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          "& .MuiDataGrid-cell": {
            display: "flex",
            alignItems: "center",
            paddingLeft: 2,
            paddingRight: 2,
          },
          "& .MuiDataGrid-row:hover": { backgroundColor: "#F3F2F1" },
        }}
      />
    </Stack>
  );
};
